var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-autocomplete',{attrs:{"label":_vm.extractedLabel,"data":_vm.search,"disabled":_vm.disabled,"selected":_vm.selected},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }